import script from "./GraphChart.vue?vue&type=script&setup=true&lang=js"
export * from "./GraphChart.vue?vue&type=script&setup=true&lang=js"

import "./GraphChart.vue?vue&type=style&index=0&id=ba84d11a&scoped=true&lang=scss"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba84d11a"]])

export default __exports__